import axios from 'axios';

// Brevo API Configuration
const BREVO_API_KEY = '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';
const BREVO_API_URL = 'https://api.brevo.com/v3/smtp/email';
const FROM_EMAIL = 'notify@tazatropics.com';
const FROM_NAME = 'Taza Tropics';

/**
 * Send order confirmation email using Brevo API
 * @param {Object} orderData - Order details
 * @returns {Promise<Object>}
 */
export const sendOrderConfirmationEmail = async (orderData) => {
  try {
    const {
      orderId,
      customerEmail,
      customerName,
      items,
      total,
      grandTotal,
      tax,
      deliveryCharge,
      address,
      paymentMethod
    } = orderData;

    // Build items HTML
    const itemsHtml = items.map(item => {
      const variantText = item.selectedVariation 
        ? ` - ${item.selectedVariation.title}` 
        : '';
      
      // Use sell_price for discounted items, otherwise price
      // For variations, the sell_price already contains the correct discounted variant price
      const discountValue = parseFloat(item.discount) || 0;
      const itemPrice = discountValue > 0 
        ? parseFloat(item.sell_price || item.price) 
        : parseFloat(item.original_price || item.price);
      
      return `
        <tr>
          <td style="padding: 10px; border-bottom: 1px solid #eee;">
            ${item.name}${variantText}
          </td>
          <td style="padding: 10px; border-bottom: 1px solid #eee; text-align: center;">
            ${item.quantiy}
          </td>
          <td style="padding: 10px; border-bottom: 1px solid #eee; text-align: right;">
            $${itemPrice.toFixed(2)}
          </td>
          <td style="padding: 10px; border-bottom: 1px solid #eee; text-align: right;">
            $${(itemPrice * item.quantiy).toFixed(2)}
          </td>
        </tr>
      `;
    }).join('');

    // Build address HTML
    const addressHtml = address ? `
      <div style="margin: 20px 0; padding: 15px; background-color: #f9f9f9; border-radius: 5px;">
        <h3 style="margin: 0 0 10px 0; color: #333;">Delivery Address</h3>
        <p style="margin: 5px 0; color: #666;">
          ${address.house}, ${address.landmark}<br>
          ${address.address}<br>
          ${address.pincode}
        </p>
      </div>
    ` : '';

    const htmlContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
      </head>
      <body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
        <div style="background-color: #4CAF50; color: white; padding: 20px; text-align: center; border-radius: 5px 5px 0 0;">
          <h1 style="margin: 0;">Order Confirmation</h1>
          <p style="margin: 10px 0 0 0;">Thank you for your order!</p>
        </div>
        
        <div style="background-color: #f9f9f9; padding: 20px; border: 1px solid #ddd; border-top: none;">
          <p>Hi <strong>${customerName}</strong>,</p>
          <p>Your order has been successfully placed and is being processed.</p>
          
          <div style="background-color: white; padding: 15px; margin: 20px 0; border-radius: 5px;">
            <h3 style="margin: 0 0 10px 0; color: #4CAF50;">Order Details</h3>
            <p style="margin: 5px 0;"><strong>Order ID:</strong> #${orderId}</p>
            <p style="margin: 5px 0;"><strong>Payment Method:</strong> ${paymentMethod}</p>
            <p style="margin: 5px 0;"><strong>Order Date:</strong> ${new Date().toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}</p>
          </div>

          ${addressHtml}

          <div style="margin: 20px 0;">
            <h3 style="margin: 0 0 15px 0; color: #333;">Order Items</h3>
            <table style="width: 100%; border-collapse: collapse; background-color: white;">
              <thead>
                <tr style="background-color: #f5f5f5;">
                  <th style="padding: 10px; text-align: left; border-bottom: 2px solid #ddd;">Item</th>
                  <th style="padding: 10px; text-align: center; border-bottom: 2px solid #ddd;">Qty</th>
                  <th style="padding: 10px; text-align: right; border-bottom: 2px solid #ddd;">Price</th>
                  <th style="padding: 10px; text-align: right; border-bottom: 2px solid #ddd;">Total</th>
                </tr>
              </thead>
              <tbody>
                ${itemsHtml}
              </tbody>
            </table>
          </div>

          <div style="background-color: white; padding: 15px; margin: 20px 0; border-radius: 5px;">
            <table style="width: 100%;">
              <tr>
                <td style="padding: 5px; text-align: right; color: #666;">Subtotal:</td>
                <td style="padding: 5px; text-align: right; font-weight: bold; width: 100px;">$${total.toFixed(2)}</td>
              </tr>
              <tr>
                <td style="padding: 5px; text-align: right; color: #666;">Tax:</td>
                <td style="padding: 5px; text-align: right; font-weight: bold;">$${tax.toFixed(2)}</td>
              </tr>
              <tr>
                <td style="padding: 5px; text-align: right; color: #666;">Delivery Charge:</td>
                <td style="padding: 5px; text-align: right; font-weight: bold;">$${deliveryCharge.toFixed(2)}</td>
              </tr>
              <tr style="border-top: 2px solid #4CAF50;">
                <td style="padding: 10px 5px; text-align: right; font-size: 18px; color: #4CAF50;">Grand Total:</td>
                <td style="padding: 10px 5px; text-align: right; font-size: 18px; font-weight: bold; color: #4CAF50;">$${grandTotal.toFixed(2)}</td>
              </tr>
            </table>
          </div>

          <div style="background-color: #fff3cd; padding: 15px; margin: 20px 0; border-radius: 5px; border-left: 4px solid #ffc107;">
            <p style="margin: 0; color: #856404;">
              <strong>Next Steps:</strong><br>
              We're preparing your order and will notify you once it's out for delivery.
            </p>
          </div>

          <p style="color: #666; font-size: 14px; margin-top: 20px;">
            If you have any questions about your order, please contact us at 
            <a href="mailto:notify@tazatropics.com" style="color: #4CAF50;">notify@tazatropics.com</a>
          </p>
        </div>

        <div style="text-align: center; padding: 20px; color: #666; font-size: 12px;">
          <p style="margin: 5px 0;">© ${new Date().getFullYear()} Taza Tropics. All rights reserved.</p>
          <p style="margin: 5px 0;">Fresh Tropical Fruits Delivered to Your Door</p>
        </div>
      </body>
      </html>
    `;

    const emailPayload = {
      sender: {
        name: FROM_NAME,
        email: FROM_EMAIL
      },
      to: [
        {
          email: customerEmail,
          name: customerName
        }
      ],
      subject: `Order Confirmation #${orderId} - Taza Tropics`,
      htmlContent: htmlContent
    };



    const response = await axios.post(BREVO_API_URL, emailPayload, {
      headers: {
        'accept': 'application/json',
        'api-key': BREVO_API_KEY,
        'content-type': 'application/json'
      }
    });



    return {
      success: true,
      messageId: response.data.messageId,
      data: response.data
    };

  } catch (error) {
    console.error('❌ Brevo email error:', error.response?.data || error.message);
    return {
      success: false,
      error: error.response?.data || error.message
    };
  }
};

/**
 * Send simple notification email
 * @param {Object} data - Email data
 */
export const sendSimpleEmail = async ({ to, subject, message }) => {
  try {
    const emailPayload = {
      sender: {
        name: FROM_NAME,
        email: FROM_EMAIL
      },
      to: [
        {
          email: to
        }
      ],
      subject: subject,
      htmlContent: `
        <div style="font-family: Arial, sans-serif; padding: 20px;">
          <h2 style="color: #4CAF50;">${subject}</h2>
          <p>${message}</p>
          <hr>
          <p style="color: #666; font-size: 12px;">Taza Tropics - Fresh Tropical Fruits</p>
        </div>
      `
    };

    const response = await axios.post(BREVO_API_URL, emailPayload, {
      headers: {
        'accept': 'application/json',
        'api-key': BREVO_API_KEY,
        'content-type': 'application/json'
      }
    });

    return {
      success: true,
      messageId: response.data.messageId
    };

  } catch (error) {
    console.error('Brevo email error:', error.response?.data || error.message);
    return {
      success: false,
      error: error.response?.data || error.message
    };
  }
};
